import styles from "./GarallyHeader.module.css";

type Props = {
  price: string;
  subtitle?: string;
  color: string;
  body: string;
  plan: string;
};

export const GarallyHeader = (props: Props) => {
  return (
    <div className={styles.container}>
      <div className={styles.plan} style={{ backgroundColor: props.color }}>
        <span className={styles.planLabel}>{props.plan}</span>
      </div>
      <div className={styles.content}>
        <div className={styles.header}>
          <div className={styles.title}>
            <span className={styles.price} style={{ color: props.color }}>
              {props.price}
            </span>
            USD
          </div>
          <div className={styles.per}>{props.subtitle}</div>
        </div>
        <div className={styles.body}>{props.body}</div>
      </div>
    </div>
  );
};
